import { Text } from '../../ui-components/text/text';
import { BusinessCardProps } from './business-card.d';
import { EnvelopeIcon } from '../icons-library/envelope';
import { Match, Switch, useContext } from 'solid-js';
import { PhoneIcon } from '../icons-library/phone';
import { ProvoxIcon } from '../icons-library/provox';
import { IdCardIcon } from '../icons-library/id-card';
import { EmergencyIcon } from '../icons-library/emergency';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { ErrorCatcher } from '../../tools/error-catcher';
import clsx from 'clsx';

const styledAtagClass = 'group w-[26rem] mb-8 px-6 self-center';

export const BusinessCard = (componentProps: BusinessCardProps) => {
    const AppState = useContext(AppContext);
    const { localize } = AppState;

    const businessCardInner = () => {
        return (
            <div
                class={clsx(
                    'flex flex-col bg-cvi-bg-elevation-raised max-h-[20rem] h-full min-h-[12rem] text-[1.43rem] bg-no-repeat rounded-cvi-md items-center justify-center cursor-pointer py-8',
                    'transition-shadow duration-200 ease-cvi-standard group-hover:shadow-elevation-default',
                    'max-mobile:flex-row max-mobile:justify-start max-mobile:items-center max-mobile:h-[8.6rem] max-mobile:w-auto max-mobile:px-[1.1rem] max-mobile:py-0',
                    componentProps.bordered && 'border border-cvi-border-muted'
                )}
            >
                <div class="max-mobile:flex max-mobile:justify-center max-mobile:items-center max-mobile:pr-[1.1rem]">
                    <Switch>
                        <Match when={componentProps.icon === 'email'}>
                            <EnvelopeIcon ariaLabel={localize('business_card_email', 'Email')}/>
                        </Match>
                        <Match when={componentProps.icon === 'phone'}>
                            <PhoneIcon ariaLabel={localize('business_card_phone', 'Phone')}/>
                        </Match>
                        <Match when={componentProps.icon === 'idCard'}>
                            <IdCardIcon ariaLabel={localize('business_card_id_card', 'ID Card')}/>
                        </Match>
                        <Match when={componentProps.icon === 'emergency'}>
                            <EmergencyIcon ariaLabel={localize('business_card_emergency', 'Emergency')}/>
                        </Match>
                        <Match when={componentProps.icon === 'myLife'}>
                            {/* @TODO: fix later to proper icon */}
                            <img src="https://i.postimg.cc/fLNs9tbX/1200x630wa-2.png" width="3.2rem" height="3.2rem" alt={localize('business_card_my_life', 'My Life')}/>
                        </Match>
                        <Match when={componentProps.icon === 'provox'}>
                            <ProvoxIcon ariaLabel={localize('business_card_provox', 'Provox')}/>
                        </Match>
                    </Switch>
                </div>
                <div class="pt-2 pb-0 desktop:pt-[0.6rem] desktop:pb-0 max-mobile:items-center max-mobile:pb-0 max-mobile:px-[1.1rem] text-primary transition-colors duration-200 group-hover:text-cvi-fg-link">
                    <Text fontSize="larger" color="defer" align="center" class="font-cvi-medium">
                        {componentProps.text ? componentProps.text : AppState.localize('contact', 'Contact')}
                    </Text>
                </div>
            </div>
        );
    };

    return (
        <ErrorCatcher componentName='Business card'>
            <Switch
                fallback={
                    <a class={styledAtagClass} href={`${componentProps.url}`} target="_blank" rel="noopener noreferrer">
                        {businessCardInner()}
                    </a>
                }
            >
                <Match when={componentProps.icon === 'email'}>
                    <a class={styledAtagClass} href={`mailto:${componentProps.url}`} target="_blank" rel="noopener noreferrer">
                        {businessCardInner()}
                    </a>
                </Match>

                <Match when={componentProps.icon === 'phone'}>
                    <a class={styledAtagClass} href={`tel:${componentProps.url}`}>{businessCardInner()}</a>
                </Match>
            </Switch>
        </ErrorCatcher>
    );
};

BusinessCard.parseProps = (atts: any) => {
    const commonAtss = {
        icon: atts.icon,
        text: atts.text,
        bordered: atts.bordered,
        url: atts.url,
    };
    return commonAtss;
};
